$(document).ready(function(){

    $("img[src=\"https://cdn.shopify.com/s/files/1/0063/8127/3170/files/search-icon.svg?v=1756189650\"]").attr("alt", "Search Icon");
$("img[src=\"//www.fleurisse.com/cdn/shop/files/layering_april_24_high_res_final3.jpg?v=1777045686&width=3840\"]").attr("alt", "Two children sitting on a blanket in a park");
$("img[src=\"//www.fleurisse.com/cdn/shop/files/cherry_blossom_alt_hi_res_retouched2.jpg?v=1775906830&width=3840\"]").attr("alt", "Two young girls by a blooming tree overlooking a lake");
$("img[src=\"//www.fleurisse.com/cdn/shop/files/preview_images/7662671ac62e4169b1669cdcaed36774.thumbnail.0000000000_1100x.jpg?v=1773766814\"]").attr("alt", "Two young girls in pink dresses walking through a field holding hands and a basket");

    $("img[src=\"//www.fleurisse.com/cdn/shop/files/cherry_blossom_alt_hi_res_retouched2.jpg?v=1775906830&width=3840\"]").attr("alt", "Two young girls by a blooming tree overlooking a lake");
$("img[src=\"//www.fleurisse.com/cdn/shop/files/preview_images/7662671ac62e4169b1669cdcaed36774.thumbnail.0000000000_1100x.jpg?v=1773766814\"]").attr("alt", "Two young girls in pink dresses walking through a field holding hands and a basket");
$('img[src*="ARROW.svg"]').attr({'alt':'arrow icon','aria-hidden':'true'});
$("img[src=\"https://cdn.shopify.com/s/files/1/0063/8127/3170/files/ACCOUNT_ICON_adc19c01-5a46-414b-b8a2-de9111e65451.svg?v=1754025582\"]").attr("alt", "Account Icon");
$('input[name="contact[email]"]').attr('aria-label','Enter Email address');
$('label[for="NewsletterForm--sections--15533934903378__footer"]').removeAttr('for');
$('a[href="/apps/giftregistry/manage"]').attr('aria-label','Manage your gift registry');
   $("img[src=\"https://cdn.shopify.com/s/files/1/0063/8127/3170/files/Layer_1_2.png?v=1749210177\"]").attr("alt", "Gift box with ribbon bow");

   
    $("img[src=\"https://cdn.shopify.com/s/files/1/0063/8127/3170/files/SHOPPING_BAG_ICON_605d9a16-f207-4499-a0f6-cf5fc8fa0229.svg?v=1754027135\"]").attr("alt", "SHOPPING BAG ICON");
setTimeout(() => {
  $('a[id^="StandardCardNoMediaLink-template"]').removeAttr('aria-labelledby');
$('a[id^="CardLink-template"]').removeAttr('aria-labelledby');
}, 1000);

$('button.thumbnail.global-media-settings').removeAttr('aria-describedby');
$("img[src=\"//www.fleurisse.com/cdn/shop/files/SPRING_FLOWERS.png?v=1758087484\"]").attr("alt", "Fleurisse by Spring Flowers logo");
$("img[src=\"//www.fleurisse.com/cdn/shop/files/French_design_with_New_York_flair..png?v=1763380287\"]").attr("alt", "French design with New York flair text logo");
$('img[src*="LOGO_ICON_3df2b80b"]').attr('alt','Fleurisse logo');
$("img[src=\"//www.fleurisse.com/cdn/shop/files/new_york.jpg?v=1762569058&width=3200\"]").attr("alt", "Storefront of Spring Flowers with mannequins and flowers");
$("img[src=\"//www.fleurisse.com/cdn/shop/files/palm_beach.jpg?v=1762569058&width=3200\"]").attr("alt", "Spring Flowers Children\'s Boutique storefront exterior");
//$('label[for^="variant-size"]').each(function(){let f=$(this).attr('for'),g=$('label[for="'+f+'"]');if(g.length>1){g.not(':first').removeAttr('for');}});
$('input[id^="variant-size"]').attr('tabindex','0');
// fix duplicate labels
$('input[id^="variant-size"]').each(function(){
  let id = this.id;
  let labels = $('label[for="'+id+'"]');
  if(labels.length > 1){
    labels.not(':first').remove();
  }
});

// add label text
$('input[id^="variant-size"]').each(function(){
  let id = this.id;
  let val = $(this).val();
  $('label[for="'+id+'"]').text(val);
});

// add aria
$('input[id^="variant-size"]').attr('aria-label', function(){
  return 'Select size ' + $(this).val();
});

$('.menu-item').on('focusin', function(){
  $(this).addClass('is-open');
});

$('.menu-item').on('focusout', function(e){
  if(!$(this).has(e.relatedTarget).length){
    $(this).removeClass('is-open');
  }
});

$('.menu-item > a[href="#"]').on('keydown', function(e){
  if(e.key === 'Enter' || e.key === ' '){
    e.preventDefault();
    $(this).parent().toggleClass('is-open');
  }
});

$('.tab-item').on('focus keydown', function(e){

  if(e.type === 'focus' || e.key === 'Enter' || e.key === ' '){

    e.preventDefault();

    let tabId = $(this).data('tab');
    let wrapper = $(this).closest('.mega-menu-wrapper');

    // remove active
    wrapper.find('.tab-item').removeClass('active');
    wrapper.find('.tab-content').removeClass('active').hide();

    // add active
    $(this).addClass('active');
    $('#' + tabId).addClass('active').show();
  }

});
console.log("ready");
});